// extracted by mini-css-extract-plugin
export default {"title":"transclusion_title__Cisrs","content":"transclusion_content__TEw5D"};